export default __webpack_public_path__ + "header-lg.d43eb61.jpg";